/**
 * A model for an individual corporate employee
 */
export class dashboardList {
    Id:number;
    orderId: number;
    tradePartnerId: string;
    createdOn: string;
    lastUpdatedOn:string;
    returnReason: string;
    status: string;
    orderSize: string;
    createdBy: string;

    constructor(Id:number,orderId:number,tradePartnerId: string,createdOn: string,lastUpdatedOn: string,returnReason: string,status: string,orderSize: string,createdBy: string){
        this.Id=Id;
        this.orderId = orderId;
        this.tradePartnerId = tradePartnerId;
        this.createdOn = createdOn;
        this.lastUpdatedOn = lastUpdatedOn;
        this.returnReason = returnReason;
        this.status = status;
        this.orderSize = orderSize;
        this.createdBy = createdBy;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/datatable/dashboardList.ts